import { FormattedMessage } from 'react-intl';

import { Select } from '../../../../forms/select/index';
import residentialOptions from '../../../../helpers/residentialOptions';
import residentialOptionMessages from '../../../../helpers/residentialOptions.messages';
import messages from '../PersonModal.messages';
import styles from '../PersonModal.module.css';

export const ResidentialStatusQuestion = ({ name }: { name: string }) => {
    return (
        <Select
            name={name}
            label={<FormattedMessage {...messages.residentialStatus} />}
            placeholder={
                <FormattedMessage {...messages.residentialStatusPlaceholder} />
            }
            selectOptions={{
                classNameSelect: styles.ResidentialStatusSelect,
                options: residentialOptions
            }}
            messages={residentialOptionMessages}
        />
    );
};
